/*!
* Domain Check
* Compares the a given domain name against a list of allowed domains from squonk.
*/
function isAllowedDomain(oDomains, currentDomain) {
  // Do nothing if bad arguments were sent
  if (!oDomains || !currentDomain || currentDomain === '') return false;

  // Setup data to use
  const aAllowedDomains = oDomains.allowedDomains && Array.isArray(oDomains.allowedDomains) ? oDomains.allowedDomains : [],
    currentDomainLowerCase = currentDomain.toLowerCase();

  const compareDomains = function (allowedDomain) {
    const allowedDomainLowerCase = allowedDomain.toLowerCase();

    // compare domains for exact match only and return true if match found.
    if (allowedDomainLowerCase === currentDomainLowerCase) {
      return true;

    // if the current domain is longer than the allowed domain:
    // e.g. sub.site.com > site.com
    // then compare the allowed domain as ".site.com" and match the end of the string
    // Supports subdomains when the allowed domain does not include a subdomain value
    } else if (currentDomainLowerCase.length > allowedDomainLowerCase.length && currentDomainLowerCase.endsWith(`.${allowedDomainLowerCase}`)) {
      return true;
    }
  };


  // Hard Override - if all domains allowed, do no checks. Always return true
  if (oDomains.allowAllDomains === true) return true;

  // Hard Override - if there are no allowed domains, and allowAll is not TRUE, always return false
  if (aAllowedDomains.length === 0) return false;

  // Normal Checks - If allowed domains are configured, compare each against current domain
  if (aAllowedDomains.length > 0) {
    return aAllowedDomains.some(compareDomains);
  }

  // Default is to return false
  return false;
}

export default isAllowedDomain;
